import React from "react";
import { Link } from "react-router-dom";
import "./contact.scss";
export const Contact = () => {
  return (
    <>
      <div className="course-page">
        <center>
          <h1>CONTACT US</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>About</h6>
        </div>
      </div>
      <div className="col-md-12">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d4064097.7626316347!2d2.5001363623013098!3d5.8773318309719915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x1069da7f7bf8c433%3A0x6665c08e429606dd!2sUniversity%20of%20Port%20Harcourt%2C%20local%20government%2C%20Abuja%20campus%2C%20university%20of%2C%20500272%2C%20Port%20Harcourt!3m2!1d4.9069911!2d6.916194399999999!4m5!1s0x1069da7f7bf8c433%3A0x6665c08e429606dd!2suniversity%20of%20port%20harcourt!3m2!1d4.9069911!2d6.916194399999999!5e0!3m2!1sen!2sng!4v1696878322432!5m2!1sen!2sng"
          width="100%"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="col-md-8 offset-md-2 flexy mt6 contact-details">
        <div className="col-md-3">
          <h2>CONTACT INFO</h2>
          <a href="tel=+234 785 454 589">
            <i class="icofont-phone"></i> +234 785 454 589
          </a>{" "}
          <br />
          <a href="tel=+234 785 454 589">
            <i class="icofont-email"></i>info@example.com
          </a>{" "}
          <br />
          <small>
            <i class="icofont-location-pin"></i>House 09, Road 32, Mohammadpur,
            Dhaka-1200, UK
          </small>
          <h2>SOCIAL MEDIA</h2>
          <ul className="list-inline socials-list">
            <li className="list-inline-item ">
              <div className="socials">
                <a href="#" target="_blank">
                  <i class="icofont-facebook"></i>
                </a>
              </div>
            </li>{" "}
            <li className="list-inline-item socials">
              <a href="#" target="_blank">
                <i class="icofont-linkedin"></i>
              </a>
            </li>{" "}
            <li className="list-inline-item socials">
              <a href="#" target="_blank">
                <i class="icofont-instagram"></i>
              </a>
            </li>{" "}
            <li className="list-inline-item socials">
              <a href="#" target="_blank">
                <i class="icofont-twitter"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="col-md-7 contact-details offset-md-2">
          <h2>SEND YOUR MASSAGE</h2>
          <form className="contact-form">
            <div className="flexy">
              <input type="text" placeholder="name" />
              <input type="text" placeholder="email" />
            </div>
            <textarea placeholder="your message" rows="6" />
            <button>submit</button>
          </form>
        </div>
      </div>
    </>
  );
};
